import { render, staticRenderFns } from "./addAndEditGrouping.vue?vue&type=template&id=db41e050&"
import script from "./addAndEditGrouping.vue?vue&type=script&lang=js&"
export * from "./addAndEditGrouping.vue?vue&type=script&lang=js&"
import style0 from "./addAndEditGrouping.vue?vue&type=style&index=0&id=db41e050&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports